import { render } from "./ListItemBasic.vue?vue&type=template&id=00cd71d6&scoped=true&ts=true"
import script from "./ListItemBasic.vue?vue&type=script&lang=ts"
export * from "./ListItemBasic.vue?vue&type=script&lang=ts"

import "./ListItemBasic.vue?vue&type=style&index=0&id=00cd71d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cd71d6"]])

export default __exports__